import api from './axios';

export const userService = {
    getProfile: async () => {
        const response = await api.get('/users/me/');
        return response.data;
    },

    updateProfile: async (formData) => {
        // FormData is required for file upload (avatar)
        const response = await api.patch('/users/me/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    changePassword: async (data) => {
        const response = await api.post('/users/set_password/', data);
        return response.data;
    },

    getById: async (id) => {
        const response = await api.get(`/users/${id}/`);
        return response.data;
    },

    getUserStats: async (id) => {
        const response = await api.get(`/users/${id}/stats/`);
        return response.data;
    }
};
